import { render, staticRenderFns } from "./scoreExchange.vue?vue&type=template&id=14b6343b&"
import script from "./scoreExchange.vue?vue&type=script&lang=js&"
export * from "./scoreExchange.vue?vue&type=script&lang=js&"
import style0 from "./scoreExchange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports